import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import "../styles/about.css"
import { serverURL } from '../config/urls';
function About() {
    const careers = {
        "Software Engineering": {
            description: "Learn to code and build a fully-working calculator",
            img: require("../img/swe-preview.png")
        }, 
        "Financial Analysis": {
            description: "Analyze a company's financial statement and make a diagnosis",
            img: require("../img/fpna-preview.png")
        },
        "Teaching": {
            description: "Create a lesson plan and teach an AI student",
            img: require("../img/teacher-preview.png")
        },
        "UI/UX Design": {
            description: "Design a website and create a prototype",
            img: require("../img/uiux-preview.png")
        }

    }
    const [selectedFAQ, setSelectedFAQ] = useState(-1);
    const [isAuthenticated, setIsAuthenticated] = useState(true);
    const [isVisible, setIsVisible] = useState(false);
    const [selectedCareer, setSelectedCareer] = useState("Software Engineering");
    const ctaRef = useRef(null);
    


    useEffect(() => {
        // fetch(serverURL + '/auth/check', {
        //     headers: {
        //         'Authorization': `Bearer ${localStorage.getItem('token')}`
        //     }
        // })
        //     .then(response => response.json())
        //     .then(data => {
        //         if (data.isAuthenticated) {
        //             setIsAuthenticated(true);
        //         } else {
        //             setIsAuthenticated(false);
        //         }
        //     })
        //     .catch(err => {
        //         console.log(err);
        //     }
        //     );
        
        // configure fade in animation
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setIsVisible(true);
                }
            }
        );
        observer.observe(ctaRef.current);

    }, []); 
    return (
        <div className='about-page'>
            <div className='about-items row container'>
                <div className='items-left col'>
                    <h1>Find your ideal career by <span style={{textDecoration: "line-through"}}>guessing</span> trying</h1>
                    <p>Experience different careers by trying them through interactive exercises.</p>
                    {(!isAuthenticated) && <Link to="/signin"><button className='primary-btn'>Get Started</button></Link>}
                </div>
                <div className='graphic-right'>
                    <img alt="Passionate man in career" src={require("../img/guy-with-passion.jpg")} />
                </div>

            </div>

            <div className='explorer-wrapper container'>
                <div className='explorer'>
                    <div className='selection-row row'>
                        <p>I'm curious about</p>
                        <div className='dropdown'>
                            <div className='dropdown-item row' style={{backgroundColor: 'white', borderTop: "1px solid black", color: 'black', justifyContent: "space-between"}}>
                                <span>{selectedCareer}</span>
                                <i className='fa fa-chevron-down' aria-hidden="true"></i>
                            </div>
                            <div className='dropdown-content col'>
                                {
                                    Object.keys(careers).filter(career => career !== selectedCareer).map(career => {

                                        return <div className="dropdown-item list" onClick={() => {
                                            setSelectedCareer(career);
                                        }}>{career}</div>
                                    })
                                }
                            </div>

                        </div>
                    </div>
                    <div className='col' style={{justifyContent: "flex-start", alignItems: "center", marginTop: "30px", marginBottom: "30px", height: "360px"}}>
                        <p style={{color: "black", fontSize: "30px", textAlign: "center", marginTop : "0", marginBottom: "10px"}}>{careers[selectedCareer]["description"]}</p>
                        <img alt="screenshot1" style={{width: "500px", maxWidth: "90%"}} src={careers[selectedCareer]["img"]} />

                    </div>
                </div>
            </div>

            <div className='col description-container container' style={{ gap: "125px" }}>
                <div className='row' style={{ justifyContent: "center", gap: "50px" }}>
                    <div className='col description item'>
                        <h2>Feel Fulfilled</h2>
                        <p>You spend a lot of time at work, so why not choose a job you really like? Our hands-on approach lets you know what you're getting into.</p>
                        {!isAuthenticated && <a href="/signup">Get Started</a>}
                    </div>
                    <img className="item" alt="screenshot1" src={require("../img/landing-graphic-1.png")} />

                </div>

                <div className='row' style={{ justifyContent: "center", gap: "50px" }}>
                    <div style={{width: "500px", maxWidth: "90%", display: "grid", placeContent: "center"}}>
                        <img className='item' alt="screenshot1" src={require("../img/landing-graphic-2.png")} style={{width: "150px"}}/>
                    </div>
                    <div className='col description item'>
                        <h2>Save Time</h2>
                        <p>Our AI chatbot helps you narrow down your search. Tell it about your hobbies, favorite subjects, and interests and get personalized career recommendations. Then try them!</p>
                        {!isAuthenticated && <a href="/signup">Get Started</a>}
                    </div>
                </div>

                <div className='row' style={{ justifyContent: "center", gap: "50px" }}>

                    <div className='col description item'>
                        <h2>Real-World Experience</h2>
                        <p>Our careers are all backed by an industry expert. No personality quizzes, overwhelming career info websites, just hands-on discovery of your interests.</p>
                        {!isAuthenticated && <a href="/signup">Get Started</a>}
                    </div>
                    <img className='item' alt="screenshot1" src={require("../img/landing-graphic-3.png")} />

                </div>


                
            </div>

            <div className='call-to-action'>
                <div className='col' style={{flexDirection: 'column', gap: "15px"}} ref={ctaRef}>
                    <h2 className={`${isVisible ? 'fade-in' : ''}`} style={{opacity: 0}}>60% of people feel detached at work. 19% are miserable. Let’s change that.</h2>
                    {!isAuthenticated && <Link to="/signin"><button className='primary-btn'>Try Career Sample Now</button></Link>}
                </div>
            </div>

            <div className="faq container" style={{height: "500px"}}>
                <h2>FAQ</h2>
                <div className="faq-items">
                    <div className="faq-item col" style={{gap: "15px"}} onClick={() => setSelectedFAQ(selectedFAQ === 1 ? -1 : 1)}>
                        <div className="faq-question row" >
                            <h3>Who is Career Sample for?</h3>
                            <h3 style={{fontSize: 30}}>⌄</h3>
                        </div>
                        {selectedFAQ === 1 && <p>Anyone who is exploring careers and wants to learn more about them. Students are our most common users, but Career Sample is great for people who want to make a career switch too.</p>}
                    </div>
                    <div className="faq-item col" style={{gap: "15px"}} onClick={() => setSelectedFAQ(selectedFAQ === 3 ? -1 : 3)}>
                        <div className="faq-question row" >
                            <h3>How can I contact you?</h3>
                            <h3 style={{fontSize: 30}}>⌄</h3>
                        </div>
                        {selectedFAQ === 3 && <p>Feel free to email us at <a>career.sample.com@gmail.com</a></p>}
                    </div>
                </div>  

            </div>
        </div>

    );
}

export default About;